var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ui-html-page__block"
  }, [_vm.hasIntro ? _c('div', {
    staticClass: "ui-html-page-intro"
  }, [_vm.parsed.title ? _c('div', {
    staticClass: "ui-html-page__block--title"
  }, [_vm._v(" " + _vm._s(_vm.parsed.title) + " ")]) : _vm._e(), _vm.media && _vm.media.type === 'iframe' ? _c('iframe', {
    staticClass: "embedded-video",
    attrs: {
      "src": _vm.media.src,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "allowfullscreen": ""
    }
  }) : _vm.media && _vm.media.type === 'video' ? _c('video', {
    staticClass: "embedded-video",
    attrs: {
      "src": _vm.media.src,
      "poster": _vm.media.poster,
      "controls": ""
    }
  }) : _vm.media && _vm.media.type === 'image' ? _c('img', {
    staticClass: "embedded-image",
    attrs: {
      "src": _vm.media.src,
      "alt": _vm.imageAlt,
      "loading": "lazy",
      "decoding": "async"
    }
  }) : _vm._e()]) : _vm._e(), _vm.parsed.content ? _c('div', {
    staticClass: "ui-html-page__block--content ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.parsed.content)
    }
  }) : _vm.html ? _c('div', {
    staticClass: "ui-html-page__block--content ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  }) : _vm._t("html")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }